import React, { useEffect, useState } from 'react'
import Terms from '../components/Terms'
import Marquee from '../components/Marquee'
import Header from '../components/Header'
import HeaderTwo from '../components/HeaderTwo'
import Footer from '../components/Footer'
import CustomBottomNavigation from '../components/BottomNavbar'

const TermsAndServices = () => {
      const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
          };
      
          window.addEventListener("resize", handleResize);
      
          // Cleanup event listener on component unmount
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);
    
  return (
    <div>
        <Marquee />
      <Header />
      <HeaderTwo />
        <Terms />
        <Footer />
      {/* Display the bottom navigation only if it's a mobile screen */}
      {isMobile && <CustomBottomNavigation />}
        </div>
  )
}

export default TermsAndServices